<template>
    <div class="user-detail-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="doctorDetail-wrap"
             v-loading="loading">
            <div class="hospital-title">
                <div><i class="iconfont icon-tongyongbiaotiicon"></i><span>护士信息</span></div>
                <div class="title-edit"
                     v-show="!editShow"
                     @click="editShow = true"><i class="iconfont icon-edit1"></i><span>编辑</span></div>
            </div>
            <!-- 查看基本信息 -->
            <div class="doctorDetail-wrap-see"
                 v-show="!editShow">
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="avtar-cover">
                                <img v-if="doctorMessage.accountHead"
                                     :src="strUrl+ doctorMessage.accountHead"
                                     class="papers"
                                     @click="avartIn(imageUrl)">
                                <div v-else
                                     class="info-avart-none">
                                    <i class="iconfont icon-Avatar"></i>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">姓名:</div>
                                <div class="info-message">{{doctorMessage.accountName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">身份证号:</div>
                                <div class="info-message">{{doctorMessage.idCard || '暂无'}}</div>
                            </div>

                            <div class="base-info-wrap">
                                <div class="info-label">学历:</div>
                                <div class="info-message">{{doctorMessage.educationBackgroundName || '暂无'}}</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">性别:</div>
                                <div class="info-message">{{sex[doctorMessage.accountSex] || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">登录手机号:</div>
                                <div class="info-message">{{doctorMessage.phone || '暂无'}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-min">医院:</div>
                                <div class="info-message">{{doctorMessage.hospitalName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap"
                                 style="margin-bottom:16px;">
                                <div class="info-label info-label-min">角色:</div>
                                <div class="info-message">{{doctorMessage.roles || '暂无'}}</div>
                            </div>

                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-te">科室:</div>
                                <div class="info-message">{{doctorMessage.departName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap"
                                 style="margin-bottom:16px;">
                                <div class="info-label info-label-te">职称:</div>
                                <div class="info-message">{{doctorMessage.titleName || '暂无'}}</div>
                            </div>

                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap"
                                 v-if="doctorMessage.hospitalId === '34'">
                                <div class="info-label">工号:</div>
                                <div class="info-message">{{doctorMessage.accountNumber || '暂无'}}</div>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="base-info-wrap"
                         style="margin-bottom:16px;">
                        <div class="info-label info-label-min"
                             style="line-height:22px">简介:</div>
                        <div class="info-message-detail">
                            {{doctorMessage.doctorResume || '暂无'}}
                        </div>
                    </div>
                    <div class="base-info-wrap"
                         style="margin-bottom:16px;">
                        <div class="info-label info-label-min"
                             style="line-height:22px">擅长:</div>
                        <div class="info-message-detail">
                            {{doctorMessage.doctorSpecial || '暂无'}}
                        </div>
                    </div>
                </div>
                <div class="doctor-cert-info">
                    <div class="info-title">认证信息</div>
                    <div class="info-cert-wrap">
                        <div class="info-cert-item">
                            <div class="info-label">身份证正面:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img v-if="doctorMessage.idCardFront"
                                         :src="strUrl+ doctorMessage.idCardFront"
                                         class="papers"
                                         @click="toPreview(doctorMessage.idCardFront)">
                                    <div v-else
                                         class="info-message">暂无身份证正面</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 编辑信息 -->
            <el-form v-show="editShow"
                     :model="ruleForm"
                     ref="ruleForm"
                     class="rule-from">
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label-width="14px">
                                <div class="avart-wrap">
                                    <!-- 遮罩 -->
                                    <div class="cover-custom"
                                         v-show="imageUrl">
                                        <div class="cover-wrap">
                                            <i class="el-icon-zoom-in"
                                               @click="avartIn(imageUrl)"></i>
                                            <i class="el-icon-delete"
                                               @click="avartDele"></i>
                                        </div>
                                    </div>
                                    <el-upload class="avatar-uploader"
                                               action=""
                                               :auto-upload="false"
                                               :show-file-list="false"
                                               list-type="picture-card"
                                               :http-request="uploadFile"
                                               :on-change="changeUpload"
                                               accept=".jpg, .png">
                                        <img v-if="imageUrl"
                                             :src="imageUrl"
                                             class="avatar-show">
                                        <div else
                                             class="avatar-img">
                                            <i class="iconfont icon-camera"></i>
                                            <div class="uploader-title">上传头像</div>
                                        </div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="姓名"
                                          label-width="104px"
                                          prop="accountName"
                                          :rules="[{ required: true, message: '请输入姓名'}]">
                                <el-input v-model="ruleForm.accountName"
                                          placeholder="请输入姓名"
                                          :style="{width: '210px'}"
                                          size="small"
                                          maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号"
                                          label-width="104px"
                                          prop="idCard"
                                          :rules="[{ required: false, message: '请输入身份证号', trigger: 'blur' },
                                                    { required: false, message: '请输入身份证号', trigger: 'change' },
                                                    { required: false,validator: checkId, trigger: 'blur' },
                                                    { required: false,validator: checkId, trigger: 'change' }]">
                                <el-input v-model="ruleForm.idCard"
                                          placeholder="请输入身份证号"
                                          :style="{width: '210px'}"
                                          size="small"
                                          maxlength="20"></el-input>
                            </el-form-item>

                            <el-form-item label="学历"
                                          label-width="104px"
                                          prop="hospitalName">
                                <el-select v-model="ruleForm.educationBackgroundCode"
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="handleEducationChange"
                                           @clear="handleEducationChange"
                                           placeholder="请选择学历">
                                    <el-option v-for="(item,index) in educationList"
                                               :key="index"
                                               :label="item.dictDataValue"
                                               :value="item.dictDataCode"></el-option>
                                </el-select>
                            </el-form-item>

                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="性别"
                                          label-width="104px"
                                          prop="accountSex">
                                <el-radio-group v-model="ruleForm.accountSex">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="0">女</el-radio>
                                    <el-radio label="2">未知</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="登录手机号"
                                          label-width="104px"
                                          prop="phone"
                                          :rules="[{ required: true, message: '请输入登录手机号'},
                                                    { pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,required: true, message: '请输入正确的登录手机号'}]">
                                <el-input v-model="ruleForm.phone"
                                          placeholder="请输入登录手机号"
                                          :style="{width: '210px'}"
                                          size="small"
                                          :disabled="noEdit"
                                          maxlength="20">
                                </el-input>
                                <el-button type="text"
                                           class="accout-link"
                                           v-if="accountShow"
                                           @click="handleAccountShow">
                                    关联账号
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8"
                                class="auto-select">
                            <el-form-item label="医院"
                                          label-width="72px"
                                          prop="hospitalId"
                                          :rules="[{ required: true, message: '请输入医院'}]">
                                <el-select filterable
                                           clearable
                                           remote
                                           :disabled="haveDept"
                                           :remote-method="getHospital"
                                           :loading="isSearchDept"
                                           loading-text="正在搜索医院，请稍后..."
                                           v-model="ruleForm.hospitalId"
                                           placeholder="请输入关键字搜索"
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="handleHosChange"
                                           @clear="handleHosChange">
                                    <el-option :label="item.hospitalName"
                                               :value="item.hospitalId"
                                               v-for="(item, index) in hospitalList"
                                               :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="角色"
                                          label-width="72px"
                                          prop="roleIds">
                                <el-select v-model="ruleForm.roleIds"
                                           multiple
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           placeholder="请选择角色">
                                    <el-option v-for="(item,index) in roleList"
                                               :key="index"
                                               :label="item.roleName"
                                               :value="item.roleId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="科室"
                                          label-width="104px"
                                          prop="departmentId"
                                          :rules="[{ required: true, message: '请输入科室'}]">
                                <el-cascader class="form-cas-select"
                                             size="small"
                                             :style="{width: '210px'}"
                                             v-model="ruleForm.departmentId"
                                             placeholder="请选择科室"
                                             :options="departList"
                                             :props="defaultProps"
                                             @focus="isHaveHospital"
                                             :visible-arrow="false"
                                             clearable
                                             filterable></el-cascader>
                            </el-form-item>
                            <el-form-item label="职称"
                                          label-width="104px"
                                          prop="titleCode"
                                          :rules="[{ required: true, message: '请选择职称'}]">
                                <el-select v-model="ruleForm.titleCode"
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="handleTitleChange"
                                           @clear="handleTitleChange"
                                           placeholder="请选择职称">
                                    <el-option v-for="(item,index) in doctorJobList"
                                               :key="index"
                                               :label="item.dictDataValue"
                                               :value="item.dictDataCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8"
                                class='auto-select'>

                            <el-form-item label="工号"
                                          label-width="104px"
                                          prop="accountNumber"
                                          :rules="[{ required: true, message:'请输入工号'}]"
                                          v-if="ruleForm.hospitalId === '34'">
                                <el-input v-model="ruleForm.accountNumber"
                                          placeholder="请输入工号"
                                          :style="{width: '210px'}"
                                          size="small"
                                          disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item class="form-details"
                                  label="简介"
                                  label-width="72px"
                                  prop="doctorResume">
                        <el-input v-model.trim="ruleForm.doctorResume"
                                  type="textarea"
                                  :style="{width: '720px',height: '132px'}"
                                  placeholder="请输入简介"
                                  maxlength="700"
                                  show-word-limit
                                  class="introduction-detail"></el-input>
                    </el-form-item>
                    <el-form-item class="form-details"
                                  label="擅长"
                                  label-width="72px"
                                  prop="doctorSpecial">
                        <el-input v-model.trim="ruleForm.doctorSpecial"
                                  type="textarea"
                                  :style="{width: '720px',height: '132px'}"
                                  placeholder="请输入擅长"
                                  maxlength="700"
                                  show-word-limit
                                  class="introduction-detail"></el-input>
                    </el-form-item>
                </div>
                <div class="doctor-base-info cert-info">
                    <div class="info-title">认证信息<span class="heart-warning">(提示:建议图片小于10M,图片格式为png、jpg、jpeg)</span></div>
                    <el-form-item label="身份证正面"
                                  label-width="115px"
                                  class="item-last"
                                  prop="idCardFront"
                                  :rules="[{ required: true, message: '请上传身份证正面照'}]"
                                  style="padding-bottom:6px;">
                        <el-upload class="papers-uploader"
                                   :action="picUrl"
                                   :headers="headers"
                                   :on-success="handleCardFrontSuccess"
                                   :on-remove="handleCardFrontRemove"
                                   :on-preview="handlePictureCardPreview"
                                   :before-upload="beforeUploadProfile"
                                   :file-list="idCardFrontFileList"
                                   list-type="picture-card"
                                   accept=".jpg, .png, .jpeg">
                            <svg-icon icon-class="sfz_renxiang" />

                        </el-upload>

                        <div class="heart-warning">
                            请上传身份证正面照
                        </div>
                    </el-form-item>
                </div>
            </el-form>

        </div>
        <div class="add-btn-bottom"
             v-show="editShow">
            <el-button type="warning"
                       size="small"
                       @click="handleEdit()"
                       :disabled="flag">保 存</el-button>
            <el-button type="info"
                       size="small"
                       plain
                       @click="isCancle()">取 消</el-button>
        </div>
        <el-dialog :visible.sync="dialogVisible"
                   :destroy-on-close="true"
                   :show-close="false"
                   width="600px"
                   @close="clearUrl"
                   class="ww-pre-dialog">
            <img width="100%"
                 :src="dialogImageUrl"
                 alt="">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="clearUrl">
                </el-image>
            </span>
        </el-dialog>
        <!-- 裁剪图片弹框 -->
        <el-dialog :visible.sync="cropperVisible"
                   :destroy-on-close="true"
                   width="718px"
                   title="头像编辑"
                   class="ww-dialog">
            <CropperPic ref="vueCropper"
                        :imgFile="fileImg"
                        @uploadFile="uploadFile">
            </CropperPic>
        </el-dialog>
        <el-dialog :visible.sync="cropperPrewVisible"
                   :show-close="false"
                   top="30vh"
                   width="400px"
                   class="ww-pre-dialog">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="handleAvartClose">
                </el-image>
            </span>
            <img width="100%"
                 :src="imagePrewUrl"
                 alt="">
        </el-dialog>

        <el-dialog title="关联账号"
                   :visible.sync="dialogAccountVisible"
                   :close-on-click-modal="false"
                   custom-class="account-dialog"
                   width="400px"
                   top="30vh"
                   :before-close="handleClose">
            <div class="account-wrap"
                 v-loading="accountLoading">
                <el-form ref="accountForm"
                         :model="accountForm"
                         label-width="80px">
                    <el-form-item label="手机号"
                                  prop="phone"
                                  :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' },
                                                    { pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,required: true, message: '请输入正确的手机号'}]">
                        <el-input class="phone-input"
                                  placeholder="请输入手机号"
                                  @input="clearError"
                                  v-model="accountForm.phone"
                                  :disabled="phoneDisabled">
                        </el-input>
                        <p class="error-mes"
                           v-if="errorShow">该手机号已注册，点击继续将合并账号</p>
                        <p class="error-mes"
                           v-if="errorShow2">该手机号已认证，无法关联，请更改手机号</p>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="confirm-btn"
                               v-if="!nextShow"
                               @click="handleAccountConfirm">确 定</el-button>
                    <el-button class="confirm-btn"
                               v-if="nextShow"
                               @click="handleNext">继 续</el-button>
                    <el-button class="cancle-btn"
                               @click="handleAccountCancle">取 消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import { mapGetters } from 'vuex'
import { checkCard } from '@/utils/IDCard'
import { getIsCanBindPhone, postBindPhone, postMergeAccount } from '@/api/user'
import CropperPic from '@/components/cropperPic'
import { checkFileSize } from '@/utils/checkFiles'
export default {
    name: 'nurseDetail',
    data () {
        return {
            proFileUploadForm: {},
            defaultProps: {
                emitPath: false,
                label: 'groupName',
                value: 'groupId'
            },
            flag: false,
            picUrl: '',
            loading: false,
            editShow: true,
            noEdit: true,
            sex: {
                '0': '女',
                '1': '男',
                '2': '未知'
            },
            type: this.$route.query.type,
            doctorIuid: this.$route.query.doctorIuid,
            doctorMessage: {},
            breadList: [{ label: '用户管理' }, { label: '用户列表', path: '/user/userList' }, { label: '编辑' }],
            ruleForm: {
                identities: 'nurse',
                iuid: '',
                hospitalId: '', // 医院id
                hospitalName: '', // 医院名称
                accountHead: '', // 头像
                accountName: '', // 用户姓名
                accountNumber: '', // 用户账号(工号)
                accountSex: '', // 性别
                doctorResume: '', // 简介
                doctorSpecial: '', // 擅长
                educationBackgroundCode: '', // 学历code
                educationBackgroundName: '', // 学历code
                titleName: '', // 职称
                titleCode: '', // 职称code
                idCard: '', // 身份证号
                idCardFront: '', // 身份证图片正面
                phone: '', // 手机号
                departmentId: '', // 科室id
                departmentName: '', // 科室name
                groupIds: [], // 集团id 虽然没用 不传接口报错
                roleIds: [] // 角色
            },
            haveDept: false, // 搜索
            isSearchDept: false,
            searchHospitalId: '', // 搜索医院ID 关联科室
            hospitalList: [], // 搜索的医院列表
            departList: [], // 科室列表
            gropList: [], // 集团列表
            roleList: [], // 角色列表
            idCardFrontFileList: [], // 身份证正资源
            dialogImageUrl: '', // 预览
            dialogVisible: false, // 预览显示
            // 剪切图片
            fileImg: {},
            cropperVisible: false,
            imageUrl: '',
            cropperPrewVisible: false,
            dialogAccountVisible: false,
            accountShow: false,
            imagePrewUrl: '', // 头像资源
            choosedglobalList: ['填写手机号', '确认手机号'],
            deleteUrl: require('../../../assets/imgs/delete.png'),
            errorShow: false,
            errorShow2: false,
            nextShow: false,
            accountLoading: false,
            phoneDisabled: false,
            accountForm: {
                phone: ''
            },
            strUrl: '/ms-hoc-video/v1/image/download?fileName='
        }
    },
    updated () {
        if (this.$refs.vueCropper) {
            this.$refs.vueCropper.updateOption()
        }
    },
    computed: {
        ...mapGetters([
            'dictionary',
            'userInfo'
        ]),
        headers () {
            return { 'Authorization': 'Bearer ' + getToken() + '' || undefined }
        }
    },
    components: {
        CropperPic
    },
    methods: {
        // 上传图片之前 限制
        beforeUploadProfile (file) {
            this.proFileUploadForm = new FormData()
            this.proFileUploadForm.append('upfiles', file)
            return checkFileSize(file, this)
        },
        // 关联账号
        handleAccountShow () {
            this.dialogAccountVisible = true
            this.accountForm.phone = ''
            if (this.$refs['accountForm']) {
                this.$refs['accountForm'].clearValidate()
            }
        },
        // 清除 406提示
        clearError () {
            if (this.errorShow2) {
                this.errorShow2 = false
            }
        },
        // 关联手机号确定
        handleAccountConfirm () {
            this.$refs['accountForm'].validate(valid => {
                if (valid) {
                    this.handleIsCanBindPhone()
                } else {
                    return false
                }
            })
        },
        async handleIsCanBindPhone () {
            const { state, results } = await getIsCanBindPhone(this.doctorMessage.iuid, this.accountForm.phone)
            if (state === 4061) { // 该手机号已注册，点击继续将合并账号
                this.errorShow = true
                this.errorShow2 = false
                this.nextShow = true
                this.phoneDisabled = true
            }
            if (state === 406) { // 手机号已绑定
                this.errorShow = false
                this.errorShow2 = true
                this.nextShow = false
            }
            if (state === 200 && results) {
                this.handleBindPhone()
            }
        },
        // 返回state 200,results=true正常绑定手机号码
        async handleBindPhone () {
            this.accountLoading = true
            const { results } = await postBindPhone(this.doctorMessage.iuid, this.accountForm.phone)
            if (results) {
                this.$message({
                    message: '成功关联手机号',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.dialogAccountVisible = false
                // this.getData()
                this.initPhone()
            }
            this.accountLoading = false
        },
        // 继续
        async handleNext () {
            this.accountLoading = true
            const { results } = await postMergeAccount(this.doctorMessage.iuid, this.accountForm.phone)
            if (results) {
                this.$message({
                    message: '成功关联手机号',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.dialogAccountVisible = false
                // this.getData()
                this.initPhone()
            }
            this.accountLoading = false
        },
        // 关联好账号 进行 填入手机号
        initPhone () {
            this.ruleForm.phone = this.accountForm.phone
            this.accountShow = false
        },
        // 取消
        handleAccountCancle () {
            this.dialogAccountVisible = false
            this.reSetAccount()
        },
        // 关闭弹框前调用方法
        handleClose (done) {
            this.reSetAccount()
            done()
        },
        reSetAccount () {
            this.errorShow = false
            this.errorShow2 = false
            this.nextShow = false
            this.phoneDisabled = false
            this.accountForm.phone = ''
        },
        // 处理下拉列表
        getSelect () {
            this.doctorJobList = this.dictionary.HSZC
            this.educationList = this.dictionary.XL
            this.getRole()
            // this.getGroup('')
        },
        async getRole () {
            const { results } = await this.$services.hospital.getRoleList()
            this.roleList = results
        },
        async getData () {
            this.loading = true
            const { results } = await this.$services.hospital.getDoctorDetail(this.doctorIuid)
            this.doctorMessage = JSON.parse(JSON.stringify(results))
            this.handleSeeData(this.doctorMessage)
            this.handleData(results)
        },
        // 处理查看的信息
        handleSeeData (data) {
            if (data.hospitalId) {
                this.getTreeDepart(data.hospitalId, data, 'first')
            }
            // 角色
            if (data.roles) {
                let roles = data.roles
                let arr = []
                for (let j in roles) {
                    arr.push(roles[j].roleName)
                }
                data.roles = arr.join(' | ')
            }
        },
        // 获取 树状 科室
        async getTreeDepart (hosId, data, type) {
            let params = {
                hospitalId: hosId
            }
            const { results } = await this.$services.hospital.getTreeDeptList(params)
            this.departList = results
            // 科室名字
            if (type === 'first') {
                if (data.departmentVO) {
                    data.departName = data.departmentVO.groupName
                    if (data.departmentVO.parentId) {
                        this.departList.map((item) => {
                            if (item.groupId === data.departmentVO.parentId) {
                                data.departName = item.groupName + ' / ' + data.departName
                            }
                        })
                    }
                }
            }
        },
        isHaveHospital (value) {
            if (!this.searchHospitalId) {
                this.$message({
                    message: '请先输入医院',
                    customClass: 'hos-message--warning',
                    iconClass: 'el-icon-warning',
                    duration: '1000'
                })
            }
        },
        // 医院搜索
        async getHospital (value, type) {
            this.isSearchDept = true
            const params = {
                searchName: value
            }
            const { results } = await this.$services.hospital.getAllHospitalList(params)
            this.isSearchDept = false
            this.hospitalList = results
            if (type !== 'first') {
                this.departList = []
            }
        },
        // 处理编辑信息
        handleData (data) {
            let list = this.ruleForm
            if (data.idCardFront) {
                this.idCardFrontFileList = [{ name: '', url: this.strUrl + data.idCardFront }]
            }
            if (data.accountHead) {
                this.imageUrl = this.strUrl + data.accountHead
            }
            if (data.hospitalName) {
                this.getHospital(data.hospitalName, 'first')
                this.searchHospitalId = data.hospitalId
            }
            // 科室
            if (data.departmentVO) {
                list.departmentName = data.departmentVO.groupName
                list.departmentId = data.departmentVO.groupId
            }
            // 角色
            if (data.roles) {
                let roles = data.roles
                list.roleIds = []
                for (let j in roles) {
                    list.roleIds.push(roles[j].roleId)
                }
            }
            // 性别
            data.accountSex = '' + data.accountSex
            for (let key in list) {
                for (let dKey in data) {
                    if (key === dKey) {
                        list[key] = data[dKey]
                    }
                }
            }
            // 关联账号
            if (!this.ruleForm.phone) {
                this.accountShow = true
            } else {
                this.accountShow = false
            }
            this.loading = false
        },
        isCancle () {
            if (this.type === 'edit') {
                this.$router.push('/user/userList')
            } else if (this.type === 'show') {
                this.editShow = false
                // this.getData()
            }
        },
        // ----------编辑--------------//
        // ------------code name----------
        // 添加医院name
        handleHosChange (val) {
            this.searchHospitalId = val
            this.ruleForm.departmentId = ''
            this.departList = []
            let obj = {}
            obj = this.hospitalList.find((item) => {
                return item.hospitalId === val
            })
            if (val) {
                this.ruleForm.hospitalName = obj.hospitalName
                this.getTreeDepart(val)
            } else {
                this.ruleForm.hospitalName = ''
            }
        },
        // 学历name
        handleEducationChange (val) {
            let obj = {}
            obj = this.educationList.find((item) => {
                return item.dictDataCode === val
            })
            if (val) {
                this.ruleForm.educationBackgroundName = obj.dictDataValue
            } else {
                this.ruleForm.educationBackgroundName = ''
            }
        },
        // 职称name
        handleTitleChange (val) {
            let obj = {}
            obj = this.doctorJobList.find((item) => {
                return item.dictDataCode === val
            })
            if (val) {
                this.ruleForm.titleName = obj.dictDataValue
            } else {
                this.ruleForm.titleName = ''
            }
        },
        // ------------code name------------------
        // 验证身份证
        checkId (rule, value, callback) {
            if (value) {
                if (checkCard(value) === false) {
                    callback(new Error('请输入正确的身份证号'))
                } else { callback() }
            } else {
                callback()
            }
        },
        // 身份证正面图片上传
        handleCardFrontSuccess (res, file) {
            let data = res.results
            this.ruleForm.idCardFront = data[0].fileId
            this.$refs['ruleForm'].validateField('idCardFront')
        },
        // 身份证正面图片删除
        handleCardFrontRemove (file, fileList) {
            this.ruleForm.idCardFront = ''
        },
        // 编辑医生
        handleEdit () {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.handlePutDoctor()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 请求接口编辑医生
        async handlePutDoctor () {
            this.loading = true
            this.flag = true
            let param = this.ruleForm
            const { results } = await this.$services.hospital.editDoctor(param)
            this.loading = false
            this.flag = false
            if (results) {
                this.$message({
                    message: '编辑护士成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                if (this.type === 'edit') {
                    this.$router.push('/user/userList')
                } else if (this.type === 'show') {
                    this.editShow = false
                    this.getData()
                }
            }
        },
        handlePictureCardPreview (file) {
            let reg = new RegExp('ZIP')
            file.url = file.url.replace(reg, '')
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        toPreview (file) {
            let reg = new RegExp('ZIP')
            file = file.replace(reg, '')
            this.dialogImageUrl = this.strUrl + file
            this.dialogVisible = true
        },
        clearUrl () {
            this.dialogImageUrl = ''
            this.dialogVisible = false
        },
        // 剪切提交图片-------
        changeUpload (file, fileList) {
            this.fileImg = file
            this.cropperVisible = true
        },
        // 提交图片
        async uploadFile (data) {
            let hospitalId = this.userInfo.hospitalId
            let iuid = this.userInfo.iuid
            let formData = new FormData()
            formData.append('file', data)
            const { results, state } = await this.$services.hospital.imgUpload(formData, hospitalId, iuid)
            if (state === 200 && results) {
                this.cropperVisible = false
                this.imageUrl = this.strUrl + results[0].originPictureId
                this.ruleForm.accountHead = results[0].originPictureId
            } else {
                this.$refs.vueCropper.cropperLoadding = false
                this.$message({
                    message: '上传头像失败，请稍后再试',
                    customClass: 'hos-message--error',
                    iconClass: 'el-icon-error',
                    duration: '1000'
                })
            }
        },
        avartIn (file) {
            let reg = new RegExp('ZIP')
            file = file.replace(reg, '')
            this.imagePrewUrl = file
            this.cropperPrewVisible = true
        },
        avartDele () {
            this.imageUrl = ''
            this.ruleForm.accountHead = ''
        },
        handleAvartClose () {
            this.cropperPrewVisible = false
        }
    },
    created () {
        this.picUrl = `/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc`
        // this.picUrl = `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=DOCTOR_INFO_IMAGE`
        if (this.type === 'edit') {
            this.editShow = true
            this.breadList[2].label = '编辑'
        } else if (this.type === 'show') {
            this.editShow = false
            this.breadList[2].label = '护士信息'
        }
        this.getSelect()
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.user-detail-wrap-out {
    .doctorDetail-wrap {
        background: #ffffff;
        margin: 20px;
        padding: 20px 20px 0px 20px;
        overflow: hidden;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .hospital-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            display: flex;
            justify-content: space-between;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
            .title-edit {
                display: flex;
                align-items: center;
                cursor: pointer;
                i {
                    color: $icon-edit;
                }
                span {
                    margin-left: 6px;
                    color: $icon-text;
                    font-size: 12px;
                }
            }
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
        }
        .doctorDetail-wrap-see {
            .doctor-base-info {
                // padding-bottom: 20px;
                border-bottom: 1px solid #cccccc;
                padding-top: 20px;
                .base-info-wrap {
                    margin-bottom: 20px;
                    display: flex;
                    // align-items: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    line-height: 14px;
                    color: #333333;
                    .info-label {
                        margin-right: 20px;
                        width: 78px;
                        text-align: right;
                        color: #666666;
                    }
                    // .info-label-min {
                    //     min-width: 78px;
                    // }
                    .info-label-te {
                        width: 78px;
                    }
                    .info-label-min {
                        width: 44px;
                    }
                    .info-message-detail {
                        width: 60%;
                        min-width: 700px;
                        line-height: 22px;
                        // max-height: 88px;
                        word-break: break-all;
                        word-wrap: break-word;
                    }
                }
                .avtar-cover {
                    margin-bottom: 20px;
                    padding-left: 12px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 0;
                    text-align: left;
                    line-height: 14px;
                    img {
                        display: block;
                        width: 120px;
                        height: 120px;
                        cursor: pointer;
                    }
                    .info-message {
                        height: 100px;
                        line-height: 100px;
                    }
                    .info-avart-none {
                        width: 120px;
                        height: 120px;
                        background: #dcdcdc;
                        position: relative;
                        i {
                            color: #ffffff;
                            font-size: 80px;
                            position: absolute;
                            left: 20px;
                            top: 52px;
                        }
                    }
                }
            }
            .doctor-cert-info {
                padding-top: 20px;
                padding-bottom: 20px;
                // border-bottom: 1px solid #cccccc;
                .info-cert-wrap {
                    padding-left: 13px;
                    .info-cert-item {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        line-height: 14px;
                        color: #333333;
                        margin-bottom: 20px;
                        display: flex;
                        .papers {
                            display: block;
                            width: 200px;
                            height: 134px;
                            border-radius: 3px;
                            cursor: pointer;
                        }
                        .paper-sign {
                            display: block;
                            width: 70px;
                            height: 70px;
                            border-radius: 0px;
                            cursor: pointer;
                        }
                        .info-label {
                            margin-right: 20px;
                            width: 120px;
                            text-align: right;
                            color: #666666;
                        }
                        .info-pic {
                            display: flex;
                            .pic-cover {
                                margin-right: 20px;
                            }
                        }
                    }
                    .info-cert-item:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
        }
        // 编辑
        .rule-from {
            .doctor-base-info {
                border-bottom: 1px solid #cccccc;
                padding-top: 20px;
                .avart-wrap {
                    position: relative;
                    .avatar-uploader {
                        .avatar-show {
                            width: 118px;
                            height: 118px;
                        }
                        .avatar-img {
                            width: 120px;
                            height: 120px;
                            display: flex;
                            align-items: center;
                            flex-direction: column;
                            position: relative;
                            i {
                                width: 24px;
                                height: 21px;
                                font-size: 20px;
                                color: #ffffff;
                                position: absolute;
                                top: -26px;
                            }
                            div {
                                color: #ffffff;
                                font-size: 14px;
                            }
                            .uploader-title {
                                width: 56px;
                                height: 14px;
                                color: #ffffff;
                                font-size: 14px;
                            }
                        }
                    }
                    .cover-custom {
                        width: 120px;
                        height: 120px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 888;
                        .cover-wrap {
                            width: 120px;
                            height: 120px;
                            background: rgba(0, 0, 0, 0.4);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            opacity: 0;
                            i {
                                color: #ffffff;
                                font-size: 20px;
                                cursor: pointer;
                            }
                            i:first-child {
                                margin-right: 10px;
                            }
                        }
                    }
                    .cover-custom:hover .cover-wrap {
                        animation: myfirst 0.5s;
                        -moz-animation: myfirst 0.5s; /* Firefox */
                        -webkit-animation: myfirst 0.5s; /* Safari 和 Chrome */
                        -o-animation: myfirst 1s; /* Opera */
                        animation-fill-mode: forwards; /*ie9 及以下不支持 */
                        -moz-animation-fill-mode: forwards;
                        -webkit-animation-fill-mode: forwards;
                        -o-animation-fill-mode: forwards;
                    }
                    // ceshi
                    @keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    @-moz-keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    @-webkit-keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    @-o-keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }
                }
                .accout-link {
                    margin-left: 10px;
                }
            }
            .doctor-base-info:last-child {
                border-bottom: none;
            }
            .cert-info {
                // border-bottom: none;
                .papers-uploader {
                    .icon {
                        font-size: 140px;
                    }
                }
                .heart-warning {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                }
                .ele-sign {
                    .sign-qian {
                        width: 70px;
                        height: 70px;
                        position: relative;
                        .icon {
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                    }
                }
            }
            .avatar-uploader {
                .avatar-img {
                    width: 120px;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    position: relative;

                    i {
                        width: 24px;
                        height: 21px;
                        font-size: 20px;
                        color: #ffffff;
                        position: absolute;
                        top: -26px;
                    }
                    div {
                        color: #ffffff;
                        font-size: 14px;
                    }
                    .uploader-title {
                        width: 56px;
                        height: 14px;
                        color: #ffffff;
                        font-size: 14px;
                    }
                }
            }
            .form-tips-text {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                margin: 20px 0;
            }
        }
        // 标签信息开始
        .set-label {
            border-bottom: none !important;
            .label-wrap {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                padding-left: 14px;
                .label-team {
                    margin-bottom: 20px;
                    display: flex;
                    .label-team-left {
                        margin-right: 20px;
                        min-width: 56px;
                        line-height: 18px;
                    }
                    .label-team-right {
                        .label-team-select {
                            // margin-bottom: 10px;
                            color: $color-primary;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            i {
                                font-size: 18px;
                                margin-right: 8px;
                            }
                        }
                        .label-team-content {
                            display: flex;
                            flex-wrap: wrap;
                            .team-content-item {
                                margin-top: 10px;
                                margin-right: 10px;
                                display: flex;
                                align-items: center;
                                height: 24px;
                                padding: 0 10px;
                                border: 1px solid #F2F2F2;
                                border-radius: 3px;
                                color: #333333;
                                .wow-user {
                                    margin-right: 10px;
                                    font-size: 10px;
                                    color: $color-primary;
                                }
                                .wow-close {
                                    margin-left: 10px;
                                    font-size: 6px;
                                    color: #999999;
                                    cursor: pointer;
                                }
                                .wow-folder {
                                    margin-right: 10px;
                                    width: 11px;
                                    height: 11px;
                                    display: inline-block;
                                    background: url("../../../assets/imgs/folder.png") no-repeat;
                                    background-size: cover;
                                }
                            }
                        }
                    }
                }
            }
        }
        // 标签信息结束
        // 查看标签信息
        .see-set-label {
            padding-bottom: 10px;
            .info-title {
                margin-bottom: 10px;
            }
            .label-wrap {
                .label-team {
                    .label-team-left {
                        margin-top: 10px;
                        min-width: 60px;
                    }
                }
            }
        }
        // 查看标签结束
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    // 团队
    .dialog-tema-content {
        padding-right: 10px;
        height: 400px;
        overflow: auto;
        .dialog-tema-item {
            margin-bottom: 14px;
            display: flex;
            justify-content: space-between;
            .dialog-tema-item-left {
                span {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 12px;
                }
            }
            .wow-user {
                margin-right: 10px;
                font-size: 10px;
                color: $color-primary;
            }
        }
    }
    // 无数据
    .dialog-none-data {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon {
            font-size: 80px;
        }
        span {
            line-height: 14px;
            font-size: 12px;
        }
    }
}
</style>

<style lang="scss">
.user-detail-wrap-out {
    .el-textarea__inner {
        padding: 5px 15px 32px 15px !important;
    }
}
.account-dialog {
    .el-dialog__body {
        .account-wrap {
            padding-bottom: 20px;
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
            }
            .el-form-item__content {
                .phone-input {
                    width: 260px;
                    height: 32px;
                    .el-input__inner {
                        height: 32px;
                        border-radius: 3px;
                        padding: 0 10px;
                    }
                }

                .error-mes {
                    margin-left: 20px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #f36969;
                    position: relative;
                    font-family: "iconfont" !important;
                    font-style: normal;
                    -webkit-font-smoothing: antialiased;
                    &:before {
                        font-size: 16px;
                        position: absolute;
                        left: -22px;
                        top: 0;
                        content: "\E650";
                    }
                }
            }
        }

        .dialog-footer {
            height: 32px;
            display: flex;
            align-items: center;
            margin-left: 80px;
            .confirm-btn {
                background: #06aea6;
                border-radius: 3px;
                padding: 0;
                width: 100px;
                height: 32px;
                border: none;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 4px;
            }
            .cancle-btn {
                background: #f5f5f5;
                border: 1px solid #cccccc;
                border-radius: 3px;
                padding: 0;
                width: 100px;
                height: 32px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 4px;
                margin-left: 16px;
            }
        }
    }
}
// 标签弹窗布局
.el-dialog__wrapper {
    .member-wow-dialog {
        .el-dialog__body {
            padding: 0;
            .member-content {
                height: 453px;
                display: flex;
                .left-wraper {
                    padding-left: 10px;
                    width: 340px;
                    border-right: 1px solid #dcdcdc;
                    .search-content {
                        margin: 10px 0;
                        width: 319px;
                        padding-right: 10px;
                        .search-tema {
                            width: 319px;
                            vertical-align: middle;
                            .el-input__inner {
                                border-radius: 3px;
                                border-color: #dcdcdc;
                                padding: 8px 32px 8px 10px;
                                height: 32px;
                                font-size: 12px;
                            }
                            .el-input__inner::-webkit-input-placeholder {
                                font-size: 12px;
                            }

                            .el-input__suffix {
                                background: $color-primary;
                                color: #fff;
                                right: 0;
                                cursor: pointer;
                                border-radius: 0 3px 3px 0;

                                i {
                                    display: inline-block;
                                    width: 36px;
                                    font-size: 14px;
                                    line-height: 32px;
                                    border-radius: 3px;
                                }
                            }
                        }
                    }
                    .table-content {
                        margin-top: 10px;
                    }
                }
                .right-wraper {
                    width: 220px;
                    padding: 20px;
                    padding-right: 0px;
                    overflow: hidden;
                    .content_text {
                        padding-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .choose_text {
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                        }
                        .empty_text {
                            cursor: pointer;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #198eeb;
                            letter-spacing: 0;
                        }
                    }
                    .choose-member {
                        height: 396px;
                        padding-right: 20px;
                        overflow: auto;
                        margin-top: 10px;
                        padding-top: 10px;
                        .item-member {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            .icon-user1 {
                                font-size: 14px;
                                color: #06aea6;
                            }
                            .el-icon-close {
                                color: #999;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .member-text {
                                margin-left: 10px;
                                font-family: PingFangSC-Regular;
                                font-size: 12px;
                                color: #333333;
                                letter-spacing: 0;
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            background: #f9f9f9;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .dialog-footer {
                .dialog-confirm-btn {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                }
                .dialog-cancle {
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    border-radius: 3px;
                    padding: 0;
                    width: 100px;
                    height: 32px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    margin-left: 16px;
                }
            }
        }
    }
}
.dialog-tema-content {
    // checkbox
    .el-checkbox-group {
        .el-checkbox {
            display: flex;
            justify-content: space-between;
            flex-flow: row-reverse;
            margin-bottom: 14px;
            margin-right:0px;
            .el-checkbox__label {
                padding-left: 0px;
                font-size: 12px;
                float: left;
                color: #333333;
                i {
                    margin-right: 10px;
                    font-size: 12px;
                    color: $color-primary;
                }
                .depart-icon {
                    margin-right: 10px;
                }
            }
        }
    }
}
.depart-icon {
    display: inline-block;
    width: 14px;
    height: 12px;
}
</style>
